import React, { Component, useState } from "react";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
//import { startUserSession } from '../../userSession';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
//import Footer from '../../component/admin/Footer';
import "../../component/admin/MultipleReactQuillEditor";
import { MultipleReactQuillEditor } from "../../component/admin/MultipleReactQuillEditor";

const updateVideoGallery = (
  id,
  data,
  edit_video_gallery_name,
  edit_video_gallery_desc,
  imageData
) => {
  let formdata = new FormData();
  formdata.append("edit_video_gallery_name", edit_video_gallery_name);
  formdata.append("edit_video_gallery_desc", edit_video_gallery_desc);
  data.new_video_gallery_pics.forEach((album_pic) => {
    formdata.append("new_video_gallery_pics[]", album_pic);
  });
  // console.log(data.album_pic);
  data.edit_video_gallery_pics.forEach((album_pic) => {
    formdata.append("edit_video_gallery_pics[]", album_pic);
  });
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.post("/videogallery/update/" + id, formdata, {
      headers: {
        Accept: "application/json",
        "Content-Type": `multipart/form-data; boundary=${formdata._boundary}`,
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getSingleVideoGalleryData = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/videogallery/get/" + id, {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const alertStyle = {
  color: "red",
};

class EditVideoGallery extends Component {
  state = {
    fields: {},
    errors: {},
    id: "",
    edit_video_gallery_name: "",
    edit_video_gallery_desc: "",
    edit_video_gallery_pics: [],
    new_video_gallery_pics: [],
  };

  removeImage(album_pics, key) {
    console.log(album_pics, key);
    var new_video_gallery_pics = this.state.edit_video_gallery_pics.filter(
      (pic) => pic != album_pics
    );
    console.log(new_video_gallery_pics);
    this.setState({
      edit_video_gallery_pics: new_video_gallery_pics,
    });
  }

  validateForm() {
    //let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    if (!this.state.edit_video_gallery_name) {
      formIsValid = false;
      errors["edit_doctor_name"] = "*Please enter your Album name.";
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  handleChange = (event) => {
    this.setState({ errors: "" });
    let fields = this.state.fields;
    fields[event.target.name] = event.target.value;
    this.setState(
      {
        fields,
      },
      () => this.validateForm()
    );
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  DescReactQuillHandleChange = (name, val) => {
    this.setState({
      edit_video_gallery_desc: val,
    });
  };
  onFileChange(file) {
    var newFiles = Array.prototype.slice.call(file);
    this.setState({
      new_video_gallery_pics: newFiles,
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    if (this.validateForm() === true) {
      /*let fields = {};
            fields["edit_department_name"] = "";
            this.setState({ fields: fields });*/
      const id = this.state.id;
      const data = {
        edit_album_title: this.state.edit_video_gallery_name,
        edit_video_gallery_desc: this.state.edit_video_gallery_desc,
        edit_video_gallery_pics: this.state.edit_video_gallery_pics,
        new_video_gallery_pics: this.state.new_video_gallery_pics,
      };
      updateVideoGallery(
        id,
        data,
        this.state.edit_video_gallery_name,
        this.state.edit_video_gallery_desc,
        this.state.edit_video_gallery_pics
      )
        .then((res) => {
          toast.success(res.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .catch((err) => {
          toast.error(err, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        });
    } else {
      toast.error("Please provide all required fields!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };
  refreshVideoGalleryData = (id) => {
    getSingleVideoGalleryData(id)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          console.log(records);
          this.setState({
            id: records.id,
            edit_video_gallery_name: records.video_gallery_name,
            edit_video_gallery_desc: records.video_gallery_desc,
            edit_video_gallery_pics: JSON.parse(records.video_gallery_pics),
          });
        } else {
          this.setState({
            id: "",
            edit_video_gallery_name: "",
            edit_video_gallery_desc: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  componentDidMount() {
    this.refreshVideoGalleryData(this.props.match.params.id);
  }
  render() {
    return (
      <div className="fixed-left">
        <div id="wrapper">
          <Route component={LeftSidebar} />
          <div className="content-page">
            <div className="content">
              <Route component={TopHeader} />
              <div className="page-content-wrapper">
                <div className="col-lg-12">
                  <div className="card m-b-20">
                    <div className="card-body">
                      <h4 className="mt-0 header-title">Edit Video Gallery</h4>
                      <form
                        onSubmit={this.handleSubmit}
                        id="editdoctorform"
                        className="needs-validation"
                        noValidate
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Video Gallery Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="edit_video_gallery_name"
                                id="edit_video_gallery_name"
                                value={this.state.edit_video_gallery_name}
                                onChange={this.handleChange}
                                required
                                placeholder="Album Name"
                              />
                              <span style={alertStyle}>
                                {this.state.errors.edit_doctor_name}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Video Gallery Description</label>
                              <MultipleReactQuillEditor
                                id="desceditor"
                                name="desceditor"
                                value={this.state.edit_video_gallery_desc}
                                onChange={(name, val) => {
                                  this.DescReactQuillHandleChange(name, val);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Video Gallery Pictures</label>
                              <input
                                type="file"
                                multiple
                                className="form-control"
                                name="new_video_gallery_pics"
                                id="new_video_gallery_pics"
                                onChange={(event) =>
                                  this.onFileChange(event.target.files)
                                }
                                accept="jpg,png"
                                placeholder="Doctor Fees"
                              />
                              {this.state.edit_video_gallery_pics.map(
                                (album_pic, key) => {
                                  console.log(album_pic);
                                  return [
                                    <img
                                      className="mt-3"
                                      width="200"
                                      src={IMAGE_URL + "AlbumImg/" + album_pic}
                                    />,
                                    <a
                                      onClick={() =>
                                        this.removeImage(album_pic, key)
                                      }
                                    >
                                      Remove {key}{" "}
                                    </a>,
                                  ];
                                }
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div>
                            <button
                              type="submit"
                              className="btn btn-pink waves-effect waves-light"
                            >
                              Update
                            </button>
                            {/*<button type="reset" className="btn btn-secondary waves-effect m-l-5">
                                                            Cancel
                                                        </button>*/}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer autoClose={5000} />
      </div>
    );
  }
}
export default EditVideoGallery;



// WEBPACK FOOTER //
// ./src/component/admin/editVideoGallery.js